import React from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeExternalLinks from "rehype-external-links";

const HighlightMarkdown = ({ children }: { children: string }) => {
    const parts = children.split(/(==.*?==)/g);

    return (
        <>
            {parts.map((part, i) =>
                part.startsWith("==") && part.endsWith("==") ? (
                    <mark key={i} className="bg-yellow-200 text-black px-1 rounded">
                        {part.slice(2, -2)}
                    </mark>
                ) : (
                    <React.Fragment key={i}>{part}</React.Fragment>
                )
            )}
        </>
    );
};


export default function HighlightText({ text }: { text: string }) {
    // Clean up text from common LLM artifacts
    const cleanedText = text.replace(/["*]/g, "");

    // Split by highlight syntax
    const parts = cleanedText.split(/(==.*?==)/g);

    return (
        <>
            {parts.map((part, i) => {
                // Highlighted part
                if (part.startsWith("==") && part.endsWith("==")) {
                    return (
                        <mark key={i} className="bg-yellow-200 text-black px-1 rounded">
                            {part.slice(2, -2)}
                        </mark>
                    );
                }

                // Normal text with line breaks
                return part.split(/\n{1,2}/g).map((line, j, arr) => (
                    <React.Fragment key={`${i}-${j}`}>
                        {line}
                        {j < arr.length - 1 && <br />}
                    </React.Fragment>
                ));
            })}
        </>
    );
}

